import { Box, Button, Modal, Typography } from '@mui/material';

export const ApiTokenModal = ({
  recreateToken,
  isOpen,
  setIsOpen,
}: {
  recreateToken: () => void;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}) => {
  return (
    <Modal open={isOpen} onClose={() => setIsOpen(false)}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <Typography sx={{ marginBottom: 2, textAlign: 'center', color: 'white' }}>Are you sure you want to recreate your API token?</Typography>
        <Button
          sx={{ marginBottom: 2 }}
          variant="contained"
          color="primary"
          onClick={() => {
            recreateToken();
            setIsOpen(false);
          }}
        >
          {'Recreate Token'}
        </Button>
        <Button sx={{ marginBottom: 2 }} variant="contained" color="secondary" onClick={() => setIsOpen(false)}>
          {'Cancel'}
        </Button>
      </Box>
    </Modal>
  );
};
